export default "__VITE_ASSET__f3797f1b__"